import React from "react"
import styled from "styled-components"
import { inject, observer } from "mobx-react"

import constants from "~/style/constants"
import SecureImage from "~/components/traffic/lookup/landing/logos/Secure"
import FormError from "~/components/Form/ErrorText"

const SSNInput = styled.input.attrs({ type: "tel" })`
  text-align: center;
  max-width: ${(props) => (props.$compact ? "32px" : "40px")};
  width: 100%;
  height: ${(props) => (props.$compact ? "44px" : "48px")};
  &:focus {
    outline: none;
  }
  font-family: ${(props) => props.theme.fonts.avenirNextMedium};
  font-size: ${(props) => (props.$compact ? "0.9rem" : "1rem")};
  background-color: #e8e9eb;
  border-radius: 4px;
  border: 1px;
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  @media (max-width: 768px) {
    height: ${(props) => (props.$compact ? "40px" : "44px")};
    font-size: 0.9rem;
  }

  @media (max-width: 480px) {
    height: ${(props) => (props.$compact ? "36px" : "40px")};
    font-size: 0.85rem;
  }
`
const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  max-width: ${(props) => (props.$compact ? "100%" : "364px")};
  width: 100%;
  height: 70px;
  align-items: center;
  justify-content: space-evenly;
  background: white;
  border-radius: 4px;
  border: 1px solid
    ${(props) =>
      props.error ? props.theme.colors.error : constants.colors.ui.borderGray};
  box-shadow: 0px 8px 15px 0px rgba(35, 41, 48, 0.15);

  @media (max-width: 768px) {
    height: 56px;
    max-width: none;
  }

  @media (max-width: 480px) {
    height: 48px;
  }
`

@inject((all) => ({
  validateDisplayMessage: all.store.trafficLookup.validateDisplayMessage,
  addLast4SSN: all.store.trafficLookup.addLast4SSN,
  deleteLast4SSN: all.store.trafficLookup.deleteLast4SSN,
  SSNNumber1: all.store.trafficLookup.SSNNumber1,
  SSNNumber2: all.store.trafficLookup.SSNNumber2,
  SSNNumber3: all.store.trafficLookup.SSNNumber3,
  SSNNumber4: all.store.trafficLookup.SSNNumber4,
}))
@observer
class Last4SSNInput extends React.Component {
  constructor(props) {
    super(props)
    this.SSNNumber1 = React.createRef()
    this.SSNNumber2 = React.createRef()
    this.SSNNumber3 = React.createRef()
    this.SSNNumber4 = React.createRef()
    this.handleChange = this.handleChange.bind(this)
    this.handleSSNKeyDown = this.handleSSNKeyDown.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }

  handleChange(e) {
    const regex = /[0-9]/
    const isNumber = regex.test(e.target.value)
    if (isNumber) {
      this.props.addLast4SSN(e.target.name, e.target.value)
    }
    if (e.target.value.length === 1 && isNumber) {
      if (e.target.name === "SSNNumber1") {
        this.SSNNumber2.current.select()
      } else if (e.target.name === "SSNNumber2") {
        this.SSNNumber3.current.select()
      } else if (e.target.name === "SSNNumber3") {
        this.SSNNumber4.current.select()
      } else if (e.target.name === "SSNNumber4") {
        if (this.props.submitButtonRef && this.props.submitButtonRef.current) {
          this.props.submitButtonRef.current.focus()
        }
      }
    }
  }

  handleSSNKeyDown(e) {
    if (e.keyCode === 8 && e.target.value.length === 1) {
      this.props.deleteLast4SSN(e.target.name)
    } else if (e.keyCode === 8 && e.target.value.length === 0) {
      if (e.target.name === "SSNNumber2") {
        this.SSNNumber1.current.select()
        this.props.deleteLast4SSN("SSNNumber1")
      } else if (e.target.name === "SSNNumber3") {
        this.SSNNumber2.current.select()
        this.props.deleteLast4SSN("SSNNumber2")
      } else if (e.target.name === "SSNNumber4") {
        this.SSNNumber3.current.select()
        this.props.deleteLast4SSN("SSNNumber3")
      }
    }
  }

  handleClick(e) {
    const currentInput = e.target.name
    if (!this.props.SSNNumber1 || currentInput === "SSNNumber1") {
      this.SSNNumber1.current.select()
    } else if (!this.props.SSNNumber2 || currentInput === "SSNNumber2") {
      this.SSNNumber2.current.select()
    } else if (!this.props.SSNNumber3 || currentInput === "SSNNumber3") {
      this.SSNNumber3.current.select()
    }
  }

  render() {
    const SSNError = this.props.validateDisplayMessage("SSN")
    const compact = this.props.compact
    return (
      <>
        <InputWrapper error={SSNError} $compact={compact}>
          <SSNInput
            $compact={compact}
            // tabIndex="0"
            name="SSNNumber1"
            value={this.props.SSNNumber1}
            onChange={this.handleChange}
            onKeyDown={this.handleSSNKeyDown}
            ref={this.SSNNumber1}
            maxLength={1}
          />

          <SSNInput
            $compact={compact}
            // tabIndex="3"
            name="SSNNumber2"
            value={this.props.SSNNumber2}
            onChange={this.handleChange}
            onKeyDown={this.handleSSNKeyDown}
            onClick={this.handleClick}
            ref={this.SSNNumber2}
            maxLength={1}
          />

          <SSNInput
            $compact={compact}
            // tabIndex="4"
            name="SSNNumber3"
            value={this.props.SSNNumber3}
            onChange={this.handleChange}
            onKeyDown={this.handleSSNKeyDown}
            onClick={this.handleClick}
            ref={this.SSNNumber3}
            maxLength={1}
          />

          <SSNInput
            $compact={compact}
            // tabIndex="5"
            name="SSNNumber4"
            value={this.props.SSNNumber4}
            onChange={this.handleChange}
            onKeyDown={this.handleSSNKeyDown}
            onClick={this.handleClick}
            ref={this.SSNNumber4}
            maxLength={1}
          />
          <SecureImage />
        </InputWrapper>
        <FormError error={SSNError} />
      </>
    )
  }
}

export default Last4SSNInput
